import React from 'react';
import { splitTextWithUrls } from '../shared/utils/linkifyText';

const linkStyle = {
  color: 'var(--app-primary, #2563eb)',
  textDecoration: 'underline',
  wordBreak: 'break-all',
};

/**
 * Render plain text with http(s) URLs as external links.
 * Clicking a link stops propagation so parent click-to-edit shells still work.
 */
export default function LinkifiedText({ text }) {
  const segments = splitTextWithUrls(text);
  if (segments.length === 0) return null;

  return (
    <>
      {segments.map((seg, i) => {
        if (seg.type !== 'url') {
          return <React.Fragment key={i}>{seg.value}</React.Fragment>;
        }
        return (
          <a
            key={i}
            href={seg.href}
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onClick={(e) => e.stopPropagation()}
          >
            {seg.value}
          </a>
        );
      })}
    </>
  );
}
